<template>
    <div class="box_M">
        <div class="info_box_m detail">
            <div class="title">{{detailContent.title}}</div>
            <div class="source"><span>发布日期:</span>{{detailContent.date}}</div>
            <div class="content">
                <div class="content_detail" v-html="detailContent.content"></div>
                <div class="file" v-if="showFiles">
                    <h2>附件:</h2>
                    <ul>
                        <li v-for="item in detailContent.files" :key="item.name"><a :href="item.url">{{item.name}}</a></li>
                    </ul>
                </div>

                <!-- 我的报名 -->
                <div class="sign_up_box_m">
                    <h2>我的报名</h2>
                    <van-form>
                        <van-field v-for="(item,index) in form" :key="index" :label="item.name" v-model="item.value" disabled/>
                    </van-form>
                </div>
            </div>
        </div>

        <bottom-menu></bottom-menu>
    </div>
</template>

<script>
import BottomMenu from '@/components/mobile/BottomMenu.vue'
import { getTrainDetail } from '@/service/api.js'
import { dateFormat } from '@/utils/util.js'

export default {
    components: { BottomMenu },
    data() {
        return {
            detailContent:{
                title:'',
                content:'',
                date:'',
                files:[]
            },
            showFiles:false,
            form:[],
        }
    },
    beforeCreate () {
        getTrainDetail(this.$route.params.id).then(data=>{
            console.log(data);
            if (data.code !==0) {
                this.$toast(data.msg)
                if (data.msg==='账号未登录') {
                    this.$router.push({name:'M_Login'})
                }
            }else{
                // 内容展示
                this.detailContent.title = data.data.title;
                this.detailContent.date = dateFormat(data.data.pushTime,'Y年M月D日');
                if (data.data.files) {
                    this.detailContent.files = JSON.parse(data.data.files)
                }
                if(this.detailContent.files.length>0){
                    this.showFiles = true
                }
                this.detailContent.content = data.data.content

                // 表单生成
                this.form = data.data.mapList
                this.form.forEach(el => {
                    el.value = JSON.stringify(el.value).slice(1,JSON.stringify(el.value).length-1)
                });
            }
            console.log(this.form);
        });
    },
}

</script>